import { Colors, Services } from '@sigma-frontend-libs/commons'
import { TaskTypes } from '@sigmasms/shared-types'

import { buttonModes, components, icons, sizes } from '@/utils'

import button from '@/components/button'
import tag from '@/components/tag'

function renderType(h, type) {
  if (type) {
    return h(
      tag,
      {
        props: {
          label: this.getTranslate(`${Services.tasks}.subheaders.${type}.lists`)
        }
      }
    )
  }
}
function renderRecipientByType(h, item) {
  const props = {
    label: item.title,
    size: sizes.small,
    mode: buttonModes.flat,
    color: Colors.primary
  }
  const on = {}

  if (item.id) {
    return h(
      'router-link',
      {
        class: 'link',
        props: {
          to: {
            name: `${Services.contacts}.single`,
            params: { id: item.id }
          }
        }
      },
      [ h(button, { props }) ]
    )
  } else {
    on.click = () => {
      navigator.clipboard.writeText(item.title || item)
      this.addSnackbar({
        text: this.getTranslate('misc.copied'),
        type: Colors.success
      })
    }
  }

  if (item.error) {
    props.label = `${item.title}: ${item.error}`
    props.color = Colors.error
  }

  return h(button, {
    props,
    on
  })
}
function renderRecipients(h, type) {
  return h(
    'div',
    {
      class: 'tasks-analytics__recipients'
    },
    [
      this.analytics[type].map(item => {
        return renderRecipientByType.call(this, h, item)
      })
    ]
  )
}
function renderRecipientsByType(h, type) {
  return h(
    'div',
    {
      class: 'tasks-analytics__group'
    },
    [
      renderType.call(this, h, type),
      renderRecipients.call(this, h, type)
    ]
  )
}
function renderAnalytics(h) {
  if (Object.keys(this.analytics).length) {
    return h(
      'div',
      {
        class: 'tasks-analytics__body'
      },
      [
        Object.keys(this.analytics).map(type => {
          return renderRecipientsByType.call(this, h, type)
        })
      ]
    )
  }
}

function renderDialogFooter(h) {
  return h(
    'div',
    {
      class: 'tasks-analytics__footer',
      slot: 'footer'
    },
    [
      h(
        button,
        {
          props: {
            label: this.getTranslate('misc.buttons.close'),
            mode: buttonModes.flat
          },
          on: {
            click: () => {
              this.clearAnalytics()
              this.showDialog = false
            }
          }
        }
      )
    ]
  )
}
function renderDialog(h) {
  let dialogMaxWidth
  if (this.viewport.breakpoint.mdUp) {
    dialogMaxWidth = 400
  }

  return h(
    components.dialog,
    {
      props: {
        title: this.getTranslate(`${Services.tasks}.titles.analytics`),
        value: this.showDialog,
        maxWidth: dialogMaxWidth
      },
      on: {
        input: event => {
          if (event === false) {
            this.clearAnalytics()
          }
          this.showDialog = event
        }
      }
    },
    [
      renderAnalytics.call(this, h),
      renderDialogFooter.call(this, h)
    ]
  )
}

export default function(h) {
  if (this.value.type === TaskTypes['sendings:bulk']) {
    return h(
      components['list-item'],
      {
        props: {
          label: this.getTranslate(`${Services.tasks}.labels.contactLists`),
          icon: icons.quick_contacts_dialer,
          dense: true
        },
        on: {
          click: () => {
            this.analysis()
          }
        },
        scopedSlots: {
          dialog: () => {
            return renderDialog.call(this, h)
          }
        }
      }
    )
  }
}
